import { Component, Element, h } from '@stencil/core';

@Component({
  tag: 'lar-node-linked-components',
  styleUrl: 'node.scss',
  shadow: true
})

export class NodelinkedComponents {

  @Element() el!: HTMLElement;

  render() {
    return (<lar-list-header><lar-translate t="node.linkednodes" /></lar-list-header>);
  }
}